/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” and “Impulse” are registered trademarks of Frictionless Systems, LLC.
 */

@file:Suppress("MagicNumber")

package systems.frictionless.impulse.browser.style.constants

import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.rgb

val colorErrorText = Color.red
val colorBlue = rgb(68, 70, 238)
val colorWhite = Color.white
val colorGray = Color.gray
val colorBlack = Color.black
val colorLightGray = Color("#e0e0e0")

val colorInputBorderNormal = Color("#A0A0A0")
val colorInputBorderFocused = Color("black")

val colorProgressBarBackground = Color("#ffffffD0")

val colorCheckmarkUnchecked = rgb(143, 143, 143)
val colorCheckmarkHover = rgb(34, 37, 174)
val colorCheckmarkChecked = colorBlue
val colorCheckmarkCenter = colorWhite

val colorTabSelectorBorder = colorLightGray
val colorTabSelectorBackground = colorBlack
val colorTabSelectorForeground = colorWhite
